import type { TourDefinition } from '../registry'
import { back, finish, gotIt, next } from '../utils/buttons'

export const accountDetailIntroTour: TourDefinition = {
  id: 'account-detail-intro',
  displayName: 'Account detail intro',
  featureFlag: 'tour-account-detail-intro',
  trigger: 'auto',
  // Dev-panel navigation jumps to the accounts list; the user clicks an
  // account, which mounts the detail page and fires this auto tour. In real
  // use it fires on first visit to any /accounts/<id>/* route.
  targetPath: '/accounts',
  steps: [
    {
      id: 'header',
      title: 'Everything we know — at a glance',
      text: 'Firmographics, AI lead score, and recent signals live up here.',
      attachTo: { element: '[data-tour="account-detail-header"]', on: 'bottom' },
      buttons: [gotIt],
    },
    {
      id: 'tabs',
      title: 'Drill into different angles',
      text: 'Overview for the AI summary. History for activity. Contacts for people. Locations for sites.',
      attachTo: { element: '[data-tour="account-detail-tabs"]', on: 'bottom' },
      buttons: [back, next],
    },
    {
      id: 'share',
      title: 'Share with your team',
      text: 'Send a tailored account summary by email — pick which sections and contacts to include.',
      attachTo: { element: '[data-tour="account-detail-share-btn"]', on: 'left' },
      buttons: [back, finish],
    },
  ],
}
